/*
 * Collection card "See Options" popup for SIMPLE-variant products (added 2026-09-25).
 *
 * Built lean from /products/<handle>.js instead of reusing Dawn's quick-add-modal, which fetches
 * the WHOLE main-product section. QSV's PDP always renders reviews, complementary products, an
 * FAQ accordion, financing and a sticky mobile buy bar alongside the buy box, and none of that
 * belongs in a collection-card popup (and Dawn's modal doesn't strip any of it out). This modal
 * shows only: image, title, price, a variant picker, quantity, Add to Cart, and a "View full
 * details" link.
 *
 * Reuses the theme's existing ModalDialog base class (assets/global.js) for the shell: focus trap,
 * Esc to close, overlay-click to close, and returning focus to the trigger button on close all come
 * from that class for free, the same as the dormant Dawn quick-add-modal and cart-drawer. The Add to
 * Cart button posts through a hand-built <product-form> + <form action="/cart/add"> that
 * assets/product-form.js auto-upgrades exactly the same way it does the real PDP form, so the cart
 * drawer/notification updates the same way as everywhere else on the site.
 */
(function () {
  if (customElements.get('card-options-modal')) return;
  if (typeof ModalDialog === 'undefined') return;

  function escapeHtml(value) {
    // Must escape quotes too: option values like 10" x 24" go into value="" attributes.
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }


  function formatMoney(cents) {
    var amount = (Number(cents) || 0) / 100;
    return '$' + amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function firstAvailableVariant(product) {
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) return product.variants[i];
    }
    return product.variants[0];
  }

  function optionValueSets(product) {
    // Shopify's /products/<handle>.js returns product.options as an array of objects
    // ({name, position, values}), not plain strings -- guard for both just in case.
    return product.options.map(function (opt, index) {
      var optionName = typeof opt === 'string' ? opt : opt.name;
      var seen = [];
      product.variants.forEach(function (variant) {
        var value = variant.options[index];
        if (value != null && seen.indexOf(value) === -1) seen.push(value);
      });
      return { name: optionName, values: seen };
    });
  }

  function findVariant(product, selectedOptions) {
    return product.variants.find(function (variant) {
      return variant.options.every(function (value, index) {
        return value === selectedOptions[index];
      });
    });
  }

  // --- Card usage tracking (added 9/29/2026, experiment "Card Buttons"). No PII: handle, variant id, qty, value only.
  // GA4 via a GTM dataLayer event (GTM trigger regex must include card_); Clarity event too.
  // event_category/event_action/event_label mirror the params because those three are already registered
  // GA4 custom dimensions, so the data is reportable before button_type/page_type/product_handle get registered.
  function track(name, p) {
    try {
      p = p || {};
      p.page_type = /^\/products\//.test(location.pathname) ? 'product' : /^\/collections/.test(location.pathname) ? 'collection' : /^\/search/.test(location.pathname) ? 'search' : 'other';
      p.event_category = p.page_type;
      p.event_action = p.button_type || name;
      p.ab_group = window.qsvAbCard || '';
      p.event_label = p.product_handle || p.ab_group;
      // Always a GTM dataLayer event (same as mobile_nav / locator_ / compare_). A direct gtag('event')
      // call never reached GA4 here: GTM's Custom Event trigger only sees {event: ...} pushes, and gtag
      // broadcast the event to Merchant Center instead (checked live 9/29/2026).
      (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, p));
      if (typeof clarity === 'function') clarity('event', name);
    } catch (e) {}
  }
  function handleOf(el) {
    var mo = el.closest('modal-opener'), mb = mo && document.querySelector((mo.getAttribute('data-modal') || '') + ' [data-product-handle]');
    if (mb) return mb.getAttribute('data-product-handle');
    for (var n = el, i = 0; n && i < 8; n = n.parentElement, i++) {
      var a = n.tagName === 'A' ? n : n.querySelector && n.querySelector('a[href*="/products/"]');
      var m = a && /\/products\/([^/?#]+)/.exec(a.getAttribute('href') || '');
      if (m) return m[1];
    }
    return '';
  }
  document.addEventListener('click', function (e) {
    try {
      var t = e.target.closest && e.target.closest('.quick-view-button .btn_addcart, .com-view-details');
      if (!t) return;
      if (t.classList.contains('com-view-details')) {
        var b = t.closest('[data-product-handle]');
        return track('card_popup_view_details', { product_handle: b ? b.getAttribute('data-product-handle') : '' });
      }
      if (t.classList.contains('btn_addcart--soldout')) return;
      var type = t.classList.contains('btn_addcart--quickview') ? 'quick_view'
        : t.classList.contains('btn_addcart--atc') ? 'add_to_cart'
        : t.classList.contains('btn_addcart--options') ? (t.tagName === 'A' ? 'see_options_pdp' : 'see_options_popup')
        : t.classList.contains('btn_addcart--info') ? 'more_info' : 'register';
      track('card_button_click', { button_type: type, product_handle: handleOf(t) });
    } catch (err) {}
  }, true);

  // --- A/B test "Big-ticket card button" (10/29/2026). When a page shows a test card, log one
  // card_ab_exposure event and stamp the group on the cart as the hidden attribute _ab_card, so every
  // Shopify order says which group the buyer was in.
  // Stamping waits until 1.5s after load: on a visitor's first page another app creates a cart at the
  // same moment, and whichever cart cookie lands last wins (seen live 10/29). The stamp only counts once
  // the cart it landed on is the browser's cart, so a lost race simply retries on the next page.
  function abExposure() {
    try {
      var g = window.qsvAbCard;
      if (!g || !document.querySelector('.ab-card-b')) return;
      track('card_ab_exposure', { ab_group: g, product_handle: '' });
      var tok = function (s) { try { s = decodeURIComponent(s || ''); } catch (e) {} return String(s).split('?')[0]; };
      var cookieCart = function () { var c = /(?:^|;\s*)cart=([^;]+)/.exec(document.cookie); return tok(c ? c[1] : ''); };
      var stamp = function () {
        if (cookieCart() && localStorage.getItem('qsv_ab_cart') === cookieCart() + ':' + g) return;
        fetch(((window.routes && window.routes.cart_update_url) || '/cart/update') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { _ab_card: g } }),
        }).then(function (r) { return r.ok ? r.json() : null; }).then(function (c) {
          if (c && c.token && tok(c.token) === cookieCart()) localStorage.setItem('qsv_ab_cart', tok(c.token) + ':' + g);
        }).catch(function () {});
      };
      var later = function () { setTimeout(stamp, 1500); };
      if (document.readyState === 'complete') later();
      else window.addEventListener('load', later);
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', abExposure);
  else abExposure();

  // Group B's card button is the pre-9/29 Quick View (fancybox 2.1.5 + assets/quickview.js, which
  // binds .quick-view clicks and pulls the product page's .qs_main_product_row into the popup).
  // Loaded only for group B on pages that show a test card, so nobody else pays for jQuery fancybox.
  var selfSrc = document.currentScript && document.currentScript.src;
  function abLoadQuickView() {
    try {
      if (window.qsvAbCard !== 'B' || !document.querySelector('.ab-card-b .quick-view') || window.__qsvQvLoading) return;
      window.__qsvQvLoading = true;
      var css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = 'https://cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.css';
      document.head.appendChild(css);
      var load = function (src, next) { var s = document.createElement('script'); s.src = src; s.onload = next; document.head.appendChild(s); };
      // Versioned asset_url from the card (an unversioned /assets/quickview.js serves a stale CDN copy).
      var qvEl = document.querySelector('.ab-card-b [data-qv-src]');
      var qv = (qvEl && qvEl.getAttribute('data-qv-src')) || (selfSrc ? selfSrc.split('?')[0].replace(/card-options-modal(\.min)?\.js$/, 'quickview.js') : null);
      if (typeof jQuery === 'undefined' || !qv) return;
      load('https://cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js', function () { load(qv); });
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', abLoadQuickView);
  else abLoadQuickView();

  class CardOptionsModal extends ModalDialog {
    show(opener) {
      const body = this.querySelector('[data-card-options-body]');
      if (!body) return;

      opener.setAttribute('aria-disabled', 'true');
      opener.classList.add('loading');
      const openerSpinner = opener.querySelector('.loading-overlay__spinner');
      if (openerSpinner) openerSpinner.classList.remove('hidden');

      const handle = body.getAttribute('data-product-handle');
      const url = body.getAttribute('data-product-url');

      fetch(`/products/${handle}.js`, { headers: { Accept: 'application/json' } })
        .then((response) => {
          if (!response.ok) throw new Error(`Product fetch failed: ${response.status}`);
          return response.json();
        })
        .then((product) => {
          this.renderProduct(body, product, url);
          super.show(opener);
          track('card_popup_open', { product_handle: handle });
          // The chat launcher sits over the bottom of the popup on phones; hide it while open.
          document.body.classList.add('com-popup-open');
        })
        .catch((error) => {
          console.error('card-options-modal: could not load product, sending to PDP instead.', error);
          window.location.href = url;
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          if (openerSpinner) openerSpinner.classList.add('hidden');
        });
    }

    hide() {
      this._awaitingAdd = false;
      document.body.classList.remove('com-popup-open');
      super.hide();
    }

    renderProduct(body, product, url) {
      const uid = this.id;
      const optionSets = optionValueSets(product);
      const initialVariant = firstAvailableVariant(product);
      // Start on the selected variant's own photo (e.g. Red), not the product's featured image.
      const imageSrc =
        (initialVariant.featured_image && initialVariant.featured_image.src) ||
        product.featured_image ||
        (product.images && product.images[0]) ||
        '';

      // Compact layout (9/25/2026): thumbnail + title + details link, then quantity with the
      // price on the right, then the option dropdown(s), then a full-width Add to Cart.
      // Dropdowns are a custom listbox styled like the collection filter dropdowns, not a
      // native <select> (whose open list is the browser's generic menu).
      const priceHtml = (variant) =>
        `<span class="com-price-current">${formatMoney(variant.price)}</span>` +
        (variant.compare_at_price && variant.compare_at_price > variant.price
          ? ` <s class="com-price-compare">${formatMoney(variant.compare_at_price)}</s>`
          : '');

      // Four grid pieces (media, price, head, form) so the stylesheet can place them:
      // desktop = photo with price under it on the left, title + options on the right;
      // phones = photo beside title and price, options full width below.
      let html = '';
      html += '<div class="com-media">';
      if (imageSrc) {
        html +=
          `<img class="com-image" src="${escapeHtml(imageSrc)}" alt="${escapeHtml(product.title)}" loading="eager" width="400" height="400">`;
      }
      html += '</div>';
      html += `<p class="com-price" id="com-price-${escapeHtml(uid)}" aria-live="polite">${priceHtml(initialVariant)}</p>`;
      html += '<div class="com-head-text">';
      html += `<p class="com-title"><a href="${escapeHtml(url)}">${escapeHtml(product.title)}</a></p>`;
      html += `<a class="com-view-details" href="${escapeHtml(url)}">View full details</a>`;
      html += '</div>';

      const cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      html += `<product-form><form action="${cartAddUrl}" method="post" enctype="multipart/form-data" accept-charset="UTF-8" class="form com-form" data-type="add-to-cart-form" novalidate>`;
      html += '<input type="hidden" name="form_type" value="product">';
      html += '<input type="hidden" name="utf8" value="&#10003;">';

      // Add to Cart sits above the dropdowns so an open list never covers or moves it.
      html +=
        `<button type="submit" name="add" class="btn_addcart btn_addcart--atc com-add-btn"${initialVariant.available ? '' : ' disabled'}>` +
        `<span>${initialVariant.available ? 'Add to Cart' : 'Sold Out'}</span>` +
        '<span class="sold-out-message hidden">Sold Out</span>' +
        '<div class="loading-overlay__spinner hidden">' +
        '<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
        '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>' +
        '</svg></div></button>';

      // Option dropdown(s) and quantity. The dropdown with the shortest choices (e.g. Color)
      // shares the top row with Quantity; any longer dropdowns (Package, Assembly) follow
      // full width. With a single dropdown this is just "dropdown + quantity" on one row.
      const optionHtml = (option, index, modifier) => {
        const ddId = `com-dd-${uid}-${index}`;
        const current = initialVariant.options[index];
        // Some products keep Shopify's placeholder option name "Title"; show "Options" instead.
        const label = /^title$/i.test(String(option.name).trim()) ? 'Options' : option.name;
        return (
          `<div class="com-option ${modifier}" data-option-index="${index}">` +
          `<span class="com-option-label" id="${ddId}-label">${escapeHtml(label)}</span>` +
          `<div class="com-dd">` +
          `<button type="button" class="com-dd-toggle" id="${ddId}-btn" aria-haspopup="listbox" aria-expanded="false" ` +
          `aria-labelledby="${ddId}-label ${ddId}-btn" data-value="${escapeHtml(current)}">` +
          `<span class="com-dd-value">${escapeHtml(current)}</span></button>` +
          `<ul class="com-dd-list" id="${ddId}-list" role="listbox" tabindex="-1" aria-labelledby="${ddId}-label" hidden>` +
          `<li class="com-dd-header" role="presentation">${escapeHtml(label)}</li>` +
          option.values
            .map((value, i) => {
              const selected = value === current;
              return `<li class="com-dd-option" role="option" id="${ddId}-opt-${i}" data-value="${escapeHtml(value)}" aria-selected="${selected}">${escapeHtml(value)}</li>`;
            })
            .join('') +
          '</ul></div></div>'
        );
      };
      const shownOptions = optionSets
        .map((option, index) => ({ option, index, longest: Math.max.apply(null, option.values.map((v) => String(v).length)) }))
        .filter((o) => o.option.values.length > 1);
      // Only pair a dropdown with Quantity when its longest choice is short enough to read
      // in half a row; otherwise every dropdown gets a full row and Quantity goes last.
      const PAIR_MAX_CHARS = 22;
      let paired = null;
      shownOptions.forEach((o) => {
        if (o.longest <= PAIR_MAX_CHARS && (!paired || o.longest < paired.longest)) paired = o;
      });
      if (!paired && shownOptions.length === 1) paired = shownOptions[0];

      html += '<div class="com-choose-row">';
      if (paired) html += optionHtml(paired.option, paired.index, 'com-option--paired');
      const qtyId = `com-qty-${uid}`;
      html +=
        `<div class="com-qty-field">` +
        `<label class="com-option-label" for="${qtyId}">Quantity</label>` +
        `<div class="com-quantity">` +
        '<button type="button" class="com-qty-btn" data-qty-step="-1" aria-label="Decrease quantity">&minus;</button>' +
        `<input type="number" id="${qtyId}" class="com-qty-input" name="quantity" value="1" min="1" inputmode="numeric">` +
        '<button type="button" class="com-qty-btn" data-qty-step="1" aria-label="Increase quantity">+</button>' +
        '</div></div>';
      shownOptions.forEach((o) => {
        if (o !== paired) html += optionHtml(o.option, o.index, 'com-option--full');
      });
      html += '</div>';

      html += `<input type="hidden" name="id" value="${escapeHtml(initialVariant.id)}" class="com-variant-id" disabled>`;
      // A/B test "Big-ticket card button": mark popup adds of test products, same as the card form.
      if (body.hasAttribute('data-ab-eligible')) html += '<input type="hidden" name="properties[_card_add]" value="card">';
      html += '</form></product-form>';

      body.innerHTML = html;

      const toggles = Array.prototype.slice.call(body.querySelectorAll('.com-dd-toggle'));
      const variantIdInput = body.querySelector('.com-variant-id');
      const priceEl = body.querySelector('.com-price');
      const addButton = body.querySelector('.com-add-btn');
      const form = body.querySelector('form');

      const currentSelection = () => {
        const selection = initialVariant.options.slice();
        toggles.forEach((toggle) => {
          const index = Number(toggle.closest('.com-option').getAttribute('data-option-index'));
          selection[index] = toggle.getAttribute('data-value');
        });
        return selection;
      };

      let currentVariant = initialVariant;
      const applyVariant = (variant) => {
        if (variant) currentVariant = variant;
        if (!variant) {
          addButton.setAttribute('disabled', 'disabled');
          addButton.querySelector('span').textContent = 'Unavailable';
          return;
        }
        variantIdInput.value = variant.id;
        priceEl.innerHTML = priceHtml(variant);
        if (variant.available) {
          addButton.removeAttribute('disabled');
          addButton.querySelector('span').textContent = 'Add to Cart';
        } else {
          addButton.setAttribute('disabled', 'disabled');
          addButton.querySelector('span').textContent = 'Sold Out';
        }
        if (variant.featured_image && variant.featured_image.src) {
          const img = body.querySelector('.com-image');
          // Shopify returns protocol-relative URLs (//cdn...), so compare resolved addresses;
          // otherwise the same photo "changes", never fires load, and stays faded.
          const next = new URL(variant.featured_image.src, window.location.href).href;
          if (img && img.src !== next) {
            // Short fade so the shopper notices the photo changed with their pick.
            img.classList.add('is-swapping');
            const done = () => img.classList.remove('is-swapping');
            img.onload = done;
            img.onerror = done;
            setTimeout(done, 1500);
            img.src = next;
          }
        }
      };

      const qtyInput = body.querySelector('.com-qty-input');
      body.querySelectorAll('.com-qty-btn').forEach((btn) => {
        btn.addEventListener('click', () => {
          const next = (parseInt(qtyInput.value, 10) || 1) + Number(btn.getAttribute('data-qty-step'));
          qtyInput.value = Math.max(1, next);
        });
      });

      // Point every dropdown at the given option values and refresh which choices are
      // sold out for the current combination of the other dropdowns.
      const syncToggles = (values) => {
        toggles.forEach((t) => {
          const idx = Number(t.closest('.com-option').getAttribute('data-option-index'));
          const val = values[idx];
          t.setAttribute('data-value', val);
          t.querySelector('.com-dd-value').textContent = val;
          t.parentElement.querySelectorAll('.com-dd-option').forEach((o) => {
            o.setAttribute('aria-selected', String(o.getAttribute('data-value') === val));
          });
        });
        markAvailability();
      };
      const markAvailability = () => {
        const selection = currentSelection();
        toggles.forEach((t) => {
          const idx = Number(t.closest('.com-option').getAttribute('data-option-index'));
          t.parentElement.querySelectorAll('.com-dd-option').forEach((o) => {
            const val = o.getAttribute('data-value');
            const match = product.variants.find((v) =>
              v.options.every((ov, k) => (k === idx ? ov === val : ov === selection[k]))
            );
            const soldOut = !match || !match.available;
            o.classList.toggle('is-unavailable', soldOut);
            let tag = o.querySelector('.com-dd-tag');
            if (soldOut && !tag) {
              tag = document.createElement('span');
              tag.className = 'com-dd-tag';
              o.appendChild(tag);
            }
            if (tag) {
              if (soldOut) tag.textContent = match ? 'Sold out' : 'Unavailable';
              else tag.remove();
            }
          });
        });
      };

      // Custom dropdown: button + listbox. Keyboard: Enter/Space/Arrow opens, arrows move,
      // Home/End jump, Enter/Space picks, Esc/Tab closes. Esc is stopped here so it closes the
      // list without also closing the popup.
      const closeAll = (except) => {
        toggles.forEach((t) => {
          if (t === except) return;
          t.setAttribute('aria-expanded', 'false');
          t.parentElement.querySelector('.com-dd-list').hidden = true;
          t.parentElement.classList.remove('opens-up');
        });
        if (!except) {
          const content = this.querySelector('.card-options-modal__content');
          if (content) content.classList.remove('has-open-dd');
        }
      };
      toggles.forEach((toggle) => {
        const list = toggle.parentElement.querySelector('.com-dd-list');
        const options = Array.prototype.slice.call(list.querySelectorAll('.com-dd-option'));
        let active = -1;

        const setActive = (i) => {
          options.forEach((o) => o.classList.remove('is-active'));
          active = Math.max(0, Math.min(options.length - 1, i));
          const opt = options[active];
          opt.classList.add('is-active');
          list.setAttribute('aria-activedescendant', opt.id);
          opt.scrollIntoView({ block: 'nearest' });
        };
        const dd = toggle.parentElement;
        const content = this.querySelector('.card-options-modal__content');
        const open = () => {
          closeAll(toggle);
          list.hidden = false;
          toggle.setAttribute('aria-expanded', 'true');
          // The list floats over the popup instead of stretching it. Flip it upward when
          // the space under the button is too short (e.g. the phone bottom sheet).
          if (content) content.classList.add('has-open-dd');
          const r = toggle.getBoundingClientRect();
          const below = window.innerHeight - r.bottom;
          dd.classList.toggle('opens-up', below < list.offsetHeight + 12 && r.top > below);
          const sel = options.findIndex((o) => o.getAttribute('aria-selected') === 'true');
          setActive(sel < 0 ? 0 : sel);
          list.focus({ preventScroll: true });
        };
        const close = (refocus) => {
          list.hidden = true;
          toggle.setAttribute('aria-expanded', 'false');
          dd.classList.remove('opens-up');
          if (content) content.classList.remove('has-open-dd');
          if (refocus) toggle.focus();
        };
        const choose = (i) => {
          const value = options[i].getAttribute('data-value');
          const optionIndex = Number(toggle.closest('.com-option').getAttribute('data-option-index'));
          close(true);
          const selection = currentSelection();
          selection[optionIndex] = value;
          // Multiple dropdowns: if this exact combination doesn't exist or is sold out, jump
          // to the closest one that keeps the value just picked (available first) and move
          // the other dropdowns to match, instead of leaving the shopper on "Unavailable".
          let variant = findVariant(product, selection);
          if (!variant || !variant.available) {
            const withValue = product.variants.filter((v) => v.options[optionIndex] === value);
            const best = (list) =>
              list.sort(
                (x, y) =>
                  y.options.filter((o, k) => o === selection[k]).length -
                  x.options.filter((o, k) => o === selection[k]).length
              )[0];
            variant = best(withValue.filter((v) => v.available)) || variant || best(withValue);
          }
          syncToggles(variant ? variant.options : selection);
          applyVariant(variant);
        };

        toggle.addEventListener('click', () => (list.hidden ? open() : close(false)));
        toggle.addEventListener('keydown', (e) => {
          if (['ArrowDown', 'ArrowUp', 'Enter', ' '].indexOf(e.key) > -1) {
            e.preventDefault();
            open();
          }
        });
        list.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
          else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
          else if (e.key === 'Home') { e.preventDefault(); setActive(0); }
          else if (e.key === 'End') { e.preventDefault(); setActive(options.length - 1); }
          else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(active); }
          else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(true); }
          else if (e.key === 'Tab') { close(false); }
        });
        list.addEventListener('keyup', (e) => {
          if (e.key === 'Escape') e.stopPropagation();
        });
        options.forEach((opt, i) => {
          opt.addEventListener('mousemove', () => { if (active !== i) setActive(i); });
          opt.addEventListener('click', () => choose(i));
        });
      });
      body.addEventListener('click', (e) => {
        if (!e.target.closest('.com-dd')) closeAll(null);
      });

      markAvailability();

      if (form) {
        form.addEventListener('submit', () => {
          this._awaitingAdd = true;
          const qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
          track('card_popup_add_to_cart', {
            product_handle: product.handle, variant_id: currentVariant.id, quantity: qty,
            value: Math.round(currentVariant.price * qty) / 100, currency: 'USD',
          });
        });
      }
    }
  }

  customElements.define('card-options-modal', CardOptionsModal);

  // Close the popup once its own Add to Cart succeeds, same as Dawn's quick-add-modal does for the
  // "Choose options" flow, then let the cart drawer/notification take over. Scoped per-modal via
  // _awaitingAdd so an add from anywhere else on the page can't close an unrelated open modal.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      document.querySelectorAll('card-options-modal[open]').forEach((modal) => {
        if (modal._awaitingAdd) modal.hide();
      });
    });
  }
})();
